module.exports = __webpack_public_path__ + "img/T4-A-rc_11.fc93de09.png";